import React, { useState, useRef, useEffect } from 'react';

const PinyinSelector = ({ character, onSelect, onClose, position }) => {
  const { char, allPinyins, selectedPinyinIndex } = character;
  const [selectedIndex, setSelectedIndex] = useState(selectedPinyinIndex);

  if (!allPinyins || allPinyins.length <= 1) {
    return null;
  }

  return (
    <>
      {/* 透明遮罩层，点击关闭 */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
        }}
        onClick={onClose}
      />

      {/* 选择器 */}
      <div
        style={{
          position: 'fixed',
          top: `${position.y}px`,
          left: `${position.x}px`,
          background: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
          border: '1px solid #e5e7eb',
          padding: '8px 0',
          zIndex: 10000,
          minWidth: '140px',
          animation: 'fadeIn 0.2s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
      {/* 标题 */}
      <div style={{
        padding: '8px 12px',
        fontSize: '0.75rem',
        color: '#6b7280',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span>选择读音</span>
        <span style={{
          background: '#f3f4f6',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '0.7rem'
        }}>
          {char}
        </span>
      </div>

      {/* 选项列表 */}
      {allPinyins.map((pinyin, index) => (
        <div
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(index);
          }}
          onMouseEnter={() => setSelectedIndex(index)}
          style={{
            padding: '10px 12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: selectedIndex === index ? '#eff6ff' : 'transparent',
            transition: 'background 0.15s',
            borderLeft: selectedIndex === index ? '3px solid #3b82f6' : '3px solid transparent'
          }}
        >
          {/* 拼音 */}
          <span style={{
            fontSize: '1rem',
            fontWeight: '600',
            color: selectedIndex === index ? '#1e40af' : '#374151',
            flex: 1
          }}>
            {pinyin}
          </span>

          {/* 选中标记 */}
          {index === selectedPinyinIndex && (
            <span style={{
              fontSize: '0.75rem',
              color: '#059669',
              background: '#d1fae5',
              padding: '2px 6px',
              borderRadius: '4px'
            }}>
              当前
            </span>
          )}

          {/* 索引 */}
          <span style={{
            fontSize: '0.7rem',
            color: '#9ca3af',
            background: '#f3f4f6',
            width: '20px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px'
          }}>
            {index + 1}
          </span>
        </div>
      ))}

      {/* 底部提示 */}
      <div style={{
        padding: '8px 12px',
        fontSize: '0.7rem',
        color: '#9ca3af',
        borderTop: '1px solid #e5e7eb',
        textAlign: 'center'
      }}>
        点击选择读音
      </div>
    </div>
    </>
  );
};

export default PinyinSelector;
